import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import { FilterFormData } from "./FilterReports"
import { ToggleOffCircle, ToggleOnCircle } from "iconsax-react"

export default function SortByUser() {
  const { setValue, getValues } = useFormContext<FilterFormData>()
  const [opt, setOpt] = useState<boolean>(false)

  const fieldValue = getValues("sort")
  useEffect(() => {
    if (fieldValue !== "user") setOpt(false)
    else setOpt(true)
  }, [fieldValue])

  const handleSortByUser = () => {
    setOpt((b) => {
      setValue("sort", !b ? "user" : "createdAt")
      return !b
    })
  }

  return (
    <div
      className="flex items-end justify-between space-y-2"
      onClick={() => handleSortByUser()}
    >
      <h3 className="mb-2 font-medium text-black04">Agrupar por vendedor?</h3>
      {opt ? (
        <>
          <ToggleOnCircle size={36} variant="Bold" className="text-primary" />
        </>
      ) : (
        <ToggleOffCircle size={36} variant="Bold" className="text-black04" />
      )}
    </div>
  )
}
